"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactErrorBoundary = require("react-error-boundary");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const activeColor = '#7ac5cc';
const disabledColor = '#5e5e5e';
const shadows = {
  castShadow: true,
  receiveShadow: false
};
const CirculationPumpModelContent = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    onPointerOver,
    onClick,
    onPointerMissed,
    onPointerOut,
    thingPDIDDevice,
    position = [0, 0, 0],
    rotation = [0, 0, 0]
  } = _ref;
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/200_water_assets/205_circulation_pump.glb"));
  const color = thingPDIDDevice ? activeColor : disabledColor;
  return /*#__PURE__*/_react.default.createElement("group", {
    dispose: null,
    visible: true,
    position: position,
    rotation: rotation
  }, /*#__PURE__*/_react.default.createElement("mesh", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: [40, 40, 40]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#FF0000",
    transparent: "true",
    opacity: ".0",
    alphaTest: true
  })), /*#__PURE__*/_react.default.createElement("group", {
    onPointerOver: onPointerOver,
    onClick: onClick,
    onPointerMissed: onPointerMissed,
    onPointerOut: onPointerOut
  }, /*#__PURE__*/_react.default.createElement("mesh", {
    position: [0.68, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: [3.2, 4, 4.2]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#FF0000",
    transparent: "true",
    opacity: ".0",
    alphaTest: true
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_base'].geometry,
    material: materials['Component.WhiteDefault']
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_body'].geometry,
    material: materials['Component.WhiteDefault']
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['03_display'].geometry,
    material: materials['Component.EmissionBlau']
  }, shadows), /*#__PURE__*/_react.default.createElement("meshPhongMaterial", {
    emissive: color,
    emissiveIntensity: 2,
    color: color,
    transparent: "true",
    opacity: "1"
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['04_light_ring'].geometry,
    material: materials['Component.EmissionBlau']
  }, shadows), /*#__PURE__*/_react.default.createElement("meshPhongMaterial", {
    emissive: color,
    emissiveIntensity: 2,
    color: color,
    transparent: "true",
    opacity: "1"
  }))));
}, (prev, next) => prev.onPointerOver === next.onPointerOver && prev.onClick === next.onClick && prev.onPointerMissed === next.onPointerMissed && prev.onPointerOut === next.onPointerOut && prev.thingPDIDDevice === next.thingPDIDDevice && prev.position === next.position && prev.rotation === next.rotation);
const CirculationPumpModel = (0, _reactErrorBoundary.withErrorBoundary)(CirculationPumpModelContent, {
  FallbackComponent: () => null,
  // eslint-disable-next-line no-console
  onError: (err, info) => console.error(err, info)
});
var _default = exports.default = CirculationPumpModel;